module.exports = __webpack_public_path__ + "static/Old-Display-9c30acbed87e21a44f34105b13438fc4.png";